import React, { useState, useEffect } from "react";
import HeaderSection from './components/header';
import MenuBar from './components/MenuBar';

import Footer from './components/footer';

import CustomerTestimonialCard from './components/TestimonialCard';

import Toolkit from './components/toolkit';

import AverageAgentCommission from './components/averageAgentCommission_TabbedV5';
import queryString from "query-string";
import QueryStringContext from "./components/QueryStringContext";
import validator from "validator";
import DOMPurify from "dompurify";
import InputPropsPlayer from "./remotion/players/SocialPostPlayer";
import About from "./components/About";
import VideoAndQuote from "./components/VideoAndQuote";
import MakingMoney from "./components/MakingMoney";
import LinkCreator from "./components/Share_Link";
import GoogleForm from "./components/ContactForm_Google";
import TestimonialSlider from "./components/TestimonialSlider";



const App = () => {

  const [queryData, setQueryData] = useState({ salesRepId: 1, viewer: "" });

  useEffect(() => {
    const parsedUrl = queryString.parse(window.location.search);
    let agent = parsedUrl.agent || 1;
    let f = parsedUrl.f || "";
    let l = parsedUrl.l || "";

    
    
  
    // Validate and sanitize salesRepId
    if (!validator.isInt(agent.toString())) {
      agent = 1;
    }
  
    // Sanitize viewer
    f = decodeURIComponent(DOMPurify.sanitize(f));
    l = decodeURIComponent(DOMPurify.sanitize(l));
  
    setQueryData({
      agent: parseInt(agent),
      f: f || "",
      l: l || "",
    });
  }, []);
  
  


  return (
    <div className='App'>

<QueryStringContext.Provider value={queryData}>
      <MenuBar />
      <HeaderSection />
      <About />
      <VideoAndQuote />
      
      <MakingMoney />
      <AverageAgentCommission />
      
     

      
     

      <Toolkit />
      <InputPropsPlayer />
      
      <TestimonialSlider />
            

        <GoogleForm />
        <LinkCreator />


      </QueryStringContext.Provider>
      
      <Footer />
     
     

      

   


    </div>
  );
};

export default App;
